import React from "react";
import HeroSection from "../components/common/HeroSection";
import SectionTitle from "../components/common/SectionTitle";
import {
  FaBox,
  FaChartLine,
  FaBell,
  FaDollarSign,
  FaMobileAlt,
  FaComments,
} from "react-icons/fa";

const Products = () => {
  const features = [
    {
      icon: <FaBox className="text-blue-500 text-4xl" />,
      title: "Manage Products",
      description:
        "Using the right business application will make your job simpler and save you money over time.",
    },
    {
      icon: <FaChartLine className="text-blue-500 text-4xl" />,
      title: "Order Monitoring",
      description:
        "Efficiently track and manage orders in real-time with comprehensive order monitoring features embedded within your business.",
    },
    {
      icon: <FaBell className="text-blue-500 text-4xl" />,
      title: "Smart Notifications",
      description:
        "Stay informed and in control with intelligent notifications that provide timely updates and important alerts within your business.",
    },
    {
      icon: <FaDollarSign className="text-blue-500 text-4xl" />,
      title: "Payment Options",
      description:
        "Streamline financial transactions and enhance customer convenience with diverse payment options.",
    },
    {
      icon: <FaMobileAlt className="text-blue-500 text-4xl" />,
      title: "Web & Mobile App",
      description:
        "According to the needs of the users, we develop both Web and Mobile business apps.",
    },
    {
      icon: <FaComments className="text-blue-500 text-4xl" />,
      title: "Support",
      description:
        "Elevate customer satisfaction and address inquiries seamlessly with robust support features integrated into your application.",
    },
  ];

  const products = [
    {
      title: "InstaApp",
      description:
        "Allow us to build your App, while you focus on your business.",
      features: [
        "Leading provider of comprehensive web and mobile app solutions.",
        "Specializing in creating engaging and user-centric digital experiences.",
        "Dedicated to driving business growth through innovative technology solutions.",
      ],
      image: "/assets/images/solutions/instaapp.png",
    },
  ];

  return (
    <div className="products-page">
      <HeroSection
        title="Products"
        breadcrumb={[{ name: "Products" }]}
        background="/assets/images/about/bg.png"
      />

      <section className="py-16">
        <div className="container mx-auto px-4">
          <SectionTitle
            subtitle=""
            title="We Build Amazing Applications For Your Business, Instantly"
            className="mb-16"
          />

          <div className="space-y-20">
            {products.map((product, index) => (
              <div
                key={index}
                className={`flex flex-col ${
                  index % 2 === 0 ? "lg:flex-row-reverse" : "lg:flex-row"
                } items-center gap-8 lg:gap-16`}
              >
                <div className="lg:w-1/2">
                  <img
                    src={
                      product.image ||
                      "/assets/images/solutions/placeholder.jpg"
                    }
                    alt={product.title}
                    className="rounded-lg shadow-lg w-full object-cover h-85 md:h-90"
                  />
                </div>

                <div className="lg:w-1/2">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">
                    {product.title}
                  </h3>
                  <p className="text-gray-600 mb-6">{product.description}</p>

                  <h4 className="text-lg font-semibold text-gray-800 mb-3">
                    Key Features:
                  </h4>
                  <ul className="space-y-2">
                    {product.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-start">
                        <div className="mr-3 mt-1 text-blue-600">
                          <svg
                            className="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <span className="text-gray-600">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <button className="mt-6 inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors">
                    Visit Website
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 ml-2 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                    <a href="https://instaapp.online/" target="_blank">
                      <button
                        className="text-orange-600 text-lg border rounded py-1 px-4 font-bold 
               shadow-md transition-all duration-150 ease-in-out 
               hover:shadow-lg hover:bg-orange-50 
               active:scale-90 active:shadow-inner active:bg-orange-100"
                      >
                        InstaApp
                      </button>
                    </a>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">
              About InstaApp
            </h3>
            <p className="text-gray-600 mb-8 text-justify">
              InstaApp delivers customized web and mobile app solutions for
              businesses in industries such as restaurants, automotive, fashion,
              groceries, and more. The mission of InstaApp is to empower
              individuals and businesses to create, deploy, and manage
              high-quality web and mobile applications with ease. We strive to
              provide a comprehensive platform that enables users, regardless of
              their technical expertise, to bring their ideas to life and reach
              their target audience effectively. <br />
              <br />
              At InstaApp, we're passionate about crafting cutting-edge digital
              experiences that revolutionize how businesses thrive in the
              digital landscape. With over 10+ years of expertise, we've been at
              the forefront of driving global business transformation through
              innovative web and mobile app solutions. <br />
              <br />
              Our commitment lies in creating user-centric applications that not
              only meet but exceed expectations, catering to diverse industries
              and empowering businesses to reach new heights. We specialize in
              delivering comprehensive and tailored digital solutions that
              seamlessly integrate with our clients' objectives, amplifying
              their growth and success.
            </p>
          </div>

          <section className="py-16 bg-white">
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-3xl font-bold text-gray-800 mb-4">
                Amazing Features
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto mb-12">
                InstaApp, which provides amazing business application solutions
                for customers, will help you boost your business startup with
                web & mobile app services.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="p-6 bg-white shadow-md rounded-lg hover:shadow-lg transition-shadow duration-300"
                  >
                    <div className="flex justify-center mb-4">
                      {feature.icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <div className="mt-20 bg-blue-50 rounded-lg p-8 md:p-12">
            <div className="max-w-3xl mx-auto text-center">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Need a Custom Solution?
              </h3>
              <p className="text-gray-600 mb-8">
                We understand that every business has unique requirements. Our
                team can develop custom solutions tailored specifically to
                address your business needs.
              </p>
              <a
                href="/contact-us"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded inline-block transition-colors"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
